/**
 * BEKATEQ Tracking Helper
 *
 * Zentraler Event-Helper, der jedes Event sowohl an GTM/GA4 (dataLayer) als
 * auch an Microsoft Clarity (clarity('event', ...)) weiterreicht.
 *
 *   window.bekTrack('pb_filter_select', { filter: 'anwendung', value: 'Garage' });
 *
 * - dataLayer.push({ event: 'pb_filter_select', filter: 'anwendung', value: 'Garage' })
 *   → GTM triggert ein GA4-Event mit denselben Parametern.
 * - clarity('event', 'pb_filter_select')        → Clarity Custom Event.
 * - clarity('set', 'pb_last_filter', 'anwendung') → Clarity Custom Tag (filterbar).
 *
 * Wenn Clarity/GTM nicht geladen sind (settings leer), wird sauber weiter-
 * gepusht — bei späterem Init werden die Events nachgeholt. Kein Crash.
 *
 * Debug-Logging via settings.tracking_debug → window.__bekTrackDebug = true.
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function debugLog(name, props) {
    if (!window.__bekTrackDebug) return;
    try { console.log('[bekTrack]', name, props || {}); } catch (e) {}
  }

  /* Einen sauberen, JSON-fähigen Wert daraus machen — Clarity erwartet
     primitives für set-Tags, dataLayer akzeptiert Objects. */
  function toScalar(v) {
    if (v == null) return '';
    if (typeof v === 'number' || typeof v === 'boolean') return v;
    if (typeof v === 'string') return v;
    try { return JSON.stringify(v); } catch (e) { return String(v); }
  }

  function pushDataLayer(name, props) {
    var payload = { event: name };
    if (props) {
      for (var k in props) {
        if (props.hasOwnProperty(k)) payload[k] = props[k];
      }
    }
    window.dataLayer.push(payload);
  }

  /* GA4-direct: gtag liest dataLayer-Events nicht automatisch, der Helper
     muss sie explizit feuern. Ist tracking.liquid im GTM-Modus, ist gtag
     hier undefined → No-Op; GTM uebernimmt dann.

     send_to: window.__BEK_GA4_ID scopt jedes Event auf die GA4-Measurement-
     ID. Ohne send_to verteilt gtag das Event an ALLE registrierten
     Destinations — bekateq.de hat parallel die Google-&-YouTube-App geladen
     (GT-T9BHPV2D → AW-1003741022 + MC), wodurch pb_*-Events ungewollt
     Google-Ads-Remarketing/Conversion-Hits ausloesten. send_to fixt das.

     Ohne __BEK_GA4_ID → No-Op. Lieber gar nicht senden als an alle
     gtag-Destinations leaken. */
  function pushGtag(name, props) {
    if (typeof window.gtag !== 'function') return;
    var ga4Id = (typeof window.__BEK_GA4_ID === 'string') ? window.__BEK_GA4_ID : '';
    if (!ga4Id) return;
    try {
      var payload = { send_to: ga4Id };
      if (props) {
        for (var k in props) {
          if (!props.hasOwnProperty(k)) continue;
          if (k === 'send_to') continue;
          payload[k] = props[k];
        }
      }
      window.gtag('event', name, payload);
    } catch (e) { /* graceful */ }
  }

  function pushClarity(name, props) {
    if (typeof window.clarity !== 'function') return;
    try {
      window.clarity('event', name);
      if (props) {
        for (var k in props) {
          if (!props.hasOwnProperty(k)) continue;
          /* Clarity-Tags müssen Strings sein und sinnvoll filterbar.
             Wir prefixen mit dem Event-Namen, damit Tags pro Event-Kontext
             auseinanderhaltbar bleiben (z. B. pb_filter_select.value=Garage). */
          var tagKey = name + '.' + k;
          window.clarity('set', tagKey, String(toScalar(props[k])));
        }
      }
    } catch (e) { /* graceful */ }
  }

  function track(name, props) {
    if (!name) return;
    debugLog(name, props);
    pushDataLayer(name, props);
    pushGtag(name, props);
    pushClarity(name, props);
  }

  /* Convenience für die häufigsten Patterns */
  track.pageView = function (path) {
    track('pb_page_view', { path: path || (location && location.pathname) || '' });
  };

  /* GA4 user_properties — nur an die Theme-GA4-Property setzen (gtag user_props
     sind GA4-only; Ads/MC ignorieren sie). Schickt nichts, wenn die GA4-ID
     leer oder gtag nicht geladen ist. */
  track.setUserProperty = function (props) {
    if (typeof window.gtag !== 'function') return;
    var ga4Id = (typeof window.__BEK_GA4_ID === 'string') ? window.__BEK_GA4_ID : '';
    if (!ga4Id) return;
    try { window.gtag('set', 'user_properties', props || {}); }
    catch (e) { /* graceful */ }
    debugLog('user_property', props);
  };

  window.bekTrack = track;
})();
